"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AminoConverter = void 0;
/* eslint-disable */
const tx_1 = require("./tx");
exports.AminoConverter = {
    "/archway.rewards.v1.MsgSetContractMetadata": {
        aminoType: "/archway.rewards.v1.MsgSetContractMetadata",
        toAmino: tx_1.MsgSetContractMetadata.toAmino,
        fromAmino: tx_1.MsgSetContractMetadata.fromAmino
    },
    "/archway.rewards.v1.MsgWithdrawRewards": {
        aminoType: "/archway.rewards.v1.MsgWithdrawRewards",
        toAmino: tx_1.MsgWithdrawRewards.toAmino,
        fromAmino: tx_1.MsgWithdrawRewards.fromAmino
    },
    "/archway.rewards.v1.MsgSetFlatFee": {
        aminoType: "/archway.rewards.v1.MsgSetFlatFee",
        toAmino: tx_1.MsgSetFlatFee.toAmino,
        fromAmino: tx_1.MsgSetFlatFee.fromAmino
    },
    "/archway.rewards.v1.MsgUpdateParams": {
        aminoType: "/archway.rewards.v1.MsgUpdateParams",
        toAmino: tx_1.MsgUpdateParams.toAmino,
        fromAmino: tx_1.MsgUpdateParams.fromAmino
    }
};
//# sourceMappingURL=tx.amino.js.map